import { BotMessageSquare } from '@orgus/ui/icons';
import { AssistantSettingsView } from '../../assistant/AssistantSettingsView.tsx';
import type { SettingsSection } from '../registry.ts';

const section: SettingsSection = {
  id: 'assistant',
  title: 'Assistant',
  description: 'How far the assistant goes on its own, where it runs, and its limits.',
  order: 59,
  icon: BotMessageSquare,
  Component: AssistantSettingsView,
};
export default section;
